const BACKSPACE = 8;
const FIRST_NUMBER_KEY_CODE = 48;
const LAST_NUMBER_KEY_CODE = 57;

export const DateMixin = {
    data() {
        return {
            ref: null
        }
    },
    methods: {
        addDateMask(ref) {
            this.ref = ref;
            ref.addEventListener('keydown', this.onDateKeyPress);
        },

        onDateKeyPress(event) {
            //Accept only 4 numbers
            if (event.target.value.length > 6 && event.keyCode >= FIRST_NUMBER_KEY_CODE || event.keyCode > LAST_NUMBER_KEY_CODE) {
                event.preventDefault();
                return;
            }

            //Month should start from 0 or 1
            if (!event.target.value.length && event.keyCode > FIRST_NUMBER_KEY_CODE + 1) {
                setTimeout(() => {
                    event.target.value = '0' + event.key + ' / ';
                });
            }

            //Month should be equal or less than 12
            if (event.target.value.length === 1 && event.keyCode > FIRST_NUMBER_KEY_CODE + 2) {
                event.target.value = '01 / ';
            }

            //Add delimitr
            if (event.target.value.length === 1 && event.keyCode !== BACKSPACE) {
                setTimeout(() => {
                    event.target.value += ' / ';
                });
            }

            //Remove number before delimitr on removing delimitr
            if (event.keyCode === BACKSPACE && event.target.value.length === 5) {
                const value = event.target.value[0];
                setTimeout(() => {
                    event.target.value = value;
                });
            }
        }
    },
    beforeDestroy() {
        if (this.ref) {
            this.ref.removeEventListener('keydown', this.onDateKeyPress);
        }
    }
};


// WEBPACK FOOTER //
// ./src/mixins/DateMixin.js